export function getMerchant(state, merchantId) {
  return state.merchants[merchantId] || null
}



// WEBPACK FOOTER //
// ./client/redux/modules/merchants/selectors.js